export { default } from "./LandingPageHero";
